import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export default function Badge({
    label,
    color = 'primary',
    variant = 'outlined',
    icon,
    textVariant = 'subtitle2',
    sx,
    ...rest
}) {
    const theme = useTheme();
    const isFilled = variant === 'filled';

    // Получаем цветовую схему из theme.palette
    const getColorScheme = (colorName) => {
        if (colorName === 'default') {
            return {
                bg: theme.palette.grey[100],
                border: theme.palette.grey[300],
                text: theme.palette.text.primary
            };
        }

        const paletteColor = theme.palette[colorName];
        if (!paletteColor) {
            return {
                bg: theme.palette.grey[100],
                border: theme.palette.grey[300],
                text: theme.palette.text.primary
            };
        }

        return {
            bg: paletteColor.light,
            border: paletteColor.main,
            text: paletteColor.dark
        };
    };

    const colorScheme = getColorScheme(color);

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1.5,
                py: 0.75,
                borderRadius: 2,
                bgcolor: isFilled ? colorScheme.border : colorScheme.bg,
                border: '2px solid',
                borderColor: colorScheme.border,
                ...sx
            }}
            {...rest}
        >
            {icon && (
                <Box sx={{
                    display: 'flex',
                    color: isFilled ? '#fff' : colorScheme.text
                }}>
                    {icon}
                </Box>
            )}
            <Typography
                variant={textVariant}
                fontWeight={600}
                color={isFilled ? '#fff' : colorScheme.text}
                lineHeight={1}
            >
                {label}
            </Typography>
        </Box>
    );
}

export function StatusBadge({ label, color = 'default', textVariant = 'body1', ...rest }) {
    return (
        <Badge
            label={label}
            color={color}
            variant="filled"
            textVariant={textVariant}
            {...rest}
        />
    );
}

export function ValueBadge({ label, value, color = 'primary', textVariant = 'subtitle2', ...rest }) {
    const theme = useTheme();

    // Получаем цветовую схему из theme.palette
    const getColorScheme = (colorName) => {
        if (colorName === 'default') {
            return {
                bg: theme.palette.grey[100],
                border: theme.palette.grey[300],
                text: theme.palette.text.primary
            };
        }

        const paletteColor = theme.palette[colorName];
        if (!paletteColor) {
            return {
                bg: theme.palette.grey[100],
                border: theme.palette.grey[300],
                text: theme.palette.text.primary
            };
        }

        return {
            bg: paletteColor.light,
            border: paletteColor.main,
            text: paletteColor.dark
        };
    };

    const colorScheme = getColorScheme(color);

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                borderRadius: 2,
                overflow: 'hidden',
                border: '2px solid',
                borderColor: colorScheme.border,
                ...rest.sx
            }}
        >
            <Box sx={{
                px: 1.25,
                py: 0.75,
                bgcolor: colorScheme.bg
            }}>
                <Typography
                    variant={textVariant}
                    fontWeight={500}
                    color={colorScheme.text}
                    lineHeight={1}
                >
                    {label}
                </Typography>
            </Box>
            <Box sx={{
                px: 1.25,
                py: 0.75,
                bgcolor: colorScheme.border
            }}>
                <Typography
                    variant={textVariant}
                    fontWeight={700}
                    color="#fff"
                    lineHeight={1}
                >
                    {value}
                </Typography>
            </Box>
        </Box>
    );
}
